import acceseo from 'src/static/svg/CompaniesLogos/logo-acceseo_svg.svg'
import adigital from 'src/static/svg/CompaniesLogos/logo_adigital.svg'
import aws from 'src/static/svg/CompaniesLogos/logo_aws.svg'
import bhub from 'src/static/svg/CompaniesLogos/logo_bhub.svg'
import bluco from 'src/static/svg/CompaniesLogos/logo_bluco.svg'
import digital_addiction from 'src/static/svg/CompaniesLogos/logo_digital-addiction.svg'
import digital_tactics from 'src/static/svg/CompaniesLogos/logo_digital-tactics.svg'
import edefense from 'src/static/svg/CompaniesLogos/logo_edefense.svg'
import garrigues from 'src/static/svg/CompaniesLogos/logo_garrigues.svg'
import genetsis_group from 'src/static/svg/CompaniesLogos/logo_genetsis-group.svg'
import google from 'src/static/svg/CompaniesLogos/logo_google.svg'
import google_cloud from 'src/static/svg/CompaniesLogos/Google_Cloud_logo.svg'
import honest_strategy from 'src/static/svg/CompaniesLogos/logo_honest-strategy.svg'
import ibm from 'src/static/svg/CompaniesLogos/logo_ibm.svg'
import igeneris from 'src/static/svg/CompaniesLogos/logo_igeneris.svg'
import integrarobot from 'src/static/svg/CompaniesLogos/logo_integrarobot.svg'
import improven from 'src/static/svg/CompaniesLogos/logo_improven.svg'
import innova from 'src/static/svg/CompaniesLogos/logo_innova-export.svg'
import iristrace from 'src/static/svg/CompaniesLogos/logo_iristrace.svg'
import lideres_digitales from 'src/static/svg/CompaniesLogos/logo_lideres-y-digitales.svg'
import microsoft from 'src/static/svg/CompaniesLogos/logo_microsoft.svg'
import nifty from 'src/static/svg/CompaniesLogos/logo_nifty.svg'
import nodeom from 'src/static/svg/CompaniesLogos/Nodeom.jpg'
import novalo from 'src/static/svg/CompaniesLogos/logo_novalo.svg'
import numericco from 'src/static/svg/CompaniesLogos/logo_numericco.svg'
import prodigioso from 'src/static/svg/CompaniesLogos/Prodigioso_Volcan.svg'
import product_hackers from 'src/static/svg/CompaniesLogos/logo_product-hackers.svg'
import roundcubers from 'src/static/svg/CompaniesLogos/logo_roundcubers.svg'
import sakudarte from 'src/static/svg/CompaniesLogos/logo_sakudarte.svg'
import shakers from 'src/static/svg/CompaniesLogos/logo_shakers.svg'
import sisteplant from 'src/static/svg/CompaniesLogos/logo_sisteplant.svg'
import thinking_with_you from 'src/static/svg/CompaniesLogos/thinking.svg'
import transparent_edge from 'src/static/svg/CompaniesLogos/logo_transparent-edge.svg'
import wam from 'src/static/svg/CompaniesLogos/logo_wam.svg'

export default {
    acceseo,
    adigital,
    aws,
    bhub,
    bluco,
    digital_addiction,
    digital_tactics,
    edefense,
    garrigues,
    genetsis_group,
    google,
    google_cloud,
    honest_strategy,
    ibm,
    igeneris,
    integrarobot,
    improven,
    innova,
    iristrace,
    lideres_digitales,
    microsoft,
    nifty,
    nodeom,
    novalo,
    numericco,
    prodigioso,
    product_hackers,
    roundcubers,
    sakudarte,
    shakers,
    sisteplant,
    thinking_with_you,
    transparent_edge,
    wam
}
